import { endOfDay, startOfDay } from "date-fns";

/**
 * Absences worth showing on the dashboard: a named technician, no intervention,
 * and a range that still covers today. Most recently started first, so a
 * current sick leave is not pushed out by older paid leave.
 */
export function selectDashboardUnavailabilities(
  times: EasyTech.Time[],
  now: Date = new Date()
): EasyTech.Time[] {
  const from = startOfDay(now).getTime();
  const to = endOfDay(now).getTime();

  return times
    .filter((el) => Boolean(el.technician?.firstName) && !el.workOrder)
    .filter((el) => {
      const start = new Date(el.date_from).getTime();
      const end = new Date(el.date_to).getTime();
      return start <= to && end >= from;
    })
    .sort((a, b) => new Date(b.date_from).getTime() - new Date(a.date_from).getTime());
}
